import e from "./design-system.es895.js";
function i(n) {
  var t = e(n).Element;
  return n instanceof t || n instanceof Element;
}
function a(n) {
  var t = e(n).HTMLElement;
  return n instanceof t || n instanceof HTMLElement;
}
function f(n) {
  if (typeof ShadowRoot > "u")
    return !1;
  var t = e(n).ShadowRoot;
  return n instanceof t || n instanceof ShadowRoot;
}
export {
  i as isElement,
  a as isHTMLElement,
  f as isShadowRoot
};
//# sourceMappingURL=design-system.es861.js.map
